<div class="slide-prestation" [ngStyle]="{'width': '100%'}" (click)="findCalendar($event)">
  <div id="slide-left" *ngIf="(isEdit && modifier) || (!isEdit && !modifier)">
    <div style="padding-left: 70px;height: 90px;">
      <div class="title-presatation"> {{isEdit && modifier ? 'Modification ' : 'Nouvelle '}} prestation</div>
      <div *ngIf="selectedEvent.resource || (isEdit && modifier)">
        <div class="col-sm-2" style="padding:0px;">
          <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="30" height="30"
            viewBox="0 0 40 40">
            <defs>
              <circle id="a" cx="18" cy="18" r="18" />
            </defs>
            <g fill="none" fill-rule="evenodd" transform="translate(2 2)">
              <mask id="b" fill="#fff">
                <use xlink:href="#a" />
              </mask>
              <circle cx="18" cy="18" r="19"
                [attr.stroke]="!isEdit ? selectedEvent.resource.eventColors : '#'+( eventSelected.detail.chauffeur ? eventSelected.detail.chauffeur.couleur : '')"
                stroke-opacity="1" stroke-width="2" />
              <g [attr.fill]="!isEdit ? selectedEvent.resource.eventColors : '#'+( eventSelected.detail.chauffeur ? eventSelected.detail.chauffeur.couleur : '')"
                fill-rule="nonzero" mask="url(#b)">
                <path fill-opacity=".7"
                  d="M22.508 25c-.033 1.562-5.007 5.416-5.007 5.416S12.525 26.562 12.49 25C8.291 25.398 5 29.063 5 33.527 5 37.79 8.003 38 11.934 38l1.317-.002h8.497l1.316.002C26.996 38 30 37.791 30 33.527c0-4.464-3.29-8.128-7.492-8.527z" />
                <path fill-opacity=".7" d="M17.5 27c3.217 0 5.897-4.38 6.5-8H11c.604 3.621 3.284 8 6.5 8z" />
                <path
                  d="M10.989 17H25.01c.547 0 .989-.43.989-.961 0-.531-.442-.961-.99-.961h-.269c0-2.554-1.504-4.765-3.698-5.846l-.558 3.079a.514.514 0 0 1-.599.408.504.504 0 0 1-.419-.583l.638-3.516A1.362 1.362 0 0 0 18.956 8h-1.913c-.484 0-.909.248-1.148.62l.638 3.516a.504.504 0 0 1-.51.59.513.513 0 0 1-.508-.415l-.559-3.078c-2.193 1.08-3.697 3.291-3.697 5.845h-.27a.975.975 0 0 0-.989.96c0 .532.443.962.989.962z" />
              </g>
            </g>
          </svg>
        </div>
        <div class="col-sm-10 resource">
          {{isEdit && modifier ? (eventSelected.detail.chauffeur ? ((eventSelected.detail.chauffeur.nom ||
          '') + ' ' + (eventSelected.detail.chauffeur.prenom || ''))
          : '') : selectedEvent.resource.title}}
        </div>
      </div>
    </div>
    <div class="col-sm-12" style="height:calc(100% - 110px)">
      <div class="col-sm-1" style="padding:5px;" [ngStyle]="{'margin-top': getMargin()}">
        <ul style="padding-left:0px;">
          <li [ngClass]="{'step-active':step===1, 'step-oval':step!==1}"
            [ngStyle]="{'background-color':step > 1 ? '#e7e7e7' : '' }">
            {{step === 1 ? '1' : ''}} </li>
          <li [ngClass]="{'step-active':step===2, 'step-oval':step!==2}"
            [ngStyle]="{'background-color':step > 2 ? '#e7e7e7' : '' }">
            {{step === 2 ? '2' : ''}} </li>
          <li [ngClass]="{'step-active':step===3 || step===3.1, 'step-oval':step!==3 && step!==3.1}"
            [ngStyle]="{'background-color':step > 3 || step > 3.1 ? '#e7e7e7' : '' }">
            {{step === 3 || step === 3.1 ? '3' : ''}} </li>
          <li [ngClass]="{'step-active':step===4 || step===4.1, 'step-oval':step!==4 && step!==4.1}"
            [ngStyle]="{'background-color':step > 4 || step > 4.1 ? '#e7e7e7' : '' }">
            {{step === 4 ? '4' : (step === 4.1 ? '5' : '')}} </li>

          <li [ngClass]="{'step-active':step===5, 'step-oval':step!==5}"
            [ngStyle]="{'background-color':step > 5 ? '#e7e7e7' : '' }">
            {{step === 5 ? '6' : ''}} </li>
          <li [ngClass]="{'step-active':step===5.1, 'step-oval':step!==5.1}"
            [ngStyle]="{'background-color':step > 5.1 ? '#e7e7e7' : '' }">
            {{step === 5.1 ? '6' : ''}} </li>
          <li [ngClass]="{'step-active':step===6, 'step-oval':step!==6}"
            [ngStyle]="{'background-color':step > 6 ? '#e7e7e7' : '' }">
            {{step === 6 ? '7' : ''}} </li>
          <li [ngClass]="{'step-active':step===7, 'step-oval':step!==7}"
            [ngStyle]="{'background-color':step > 7 ? '#e7e7e7' : '' }">
            {{step === 7 ? (param.gestionCQC && planning.isPartenaire ? '9' : '8') : ''}} </li>
          <li [ngClass]="{'step-active':step===7.1, 'step-oval':step!==7.1}"
            [ngStyle]="{'background-color':step > 7.1 ? '#e7e7e7' : '' }">
            {{step === 7.1 ? (param.gestionCQC ? '10' : '9') : ''}} </li>
          <li [ngClass]="{'step-active':step===8 || step===9 , 'step-oval':step!==8 && step!==9}"
            [ngStyle]="{'background-color':step > 9 ? '#e7e7e7' : '' }">
            {{step === 8 || step === 9 ? (param.gestionCQC ? '11' : '10') : ''}} </li>

        </ul>
      </div>
      <div class="col-sm-11" style="height:100%;">
        <div class="text-left uppercase btn-nav" (click)="prevStep()" *ngIf="!isEdit">
          <img src="assets/images/icons/fleche-precedent.svg" alt="precedent" /> Précédent
        </div>
        <div style="height: 0; overflow: hidden;">
          <input type="text" class="" id="inputTypeHidden" autocomplete="off" (keyup.enter)="keyEnterHideInput();">
        </div>
        <div class="add-prestation" [ngSwitch]="step">
          <div class="col-sm-12" style="padding: 5px; height:100%">
            <div *ngSwitchCase="1" class="etape1">
              <div style="margin-bottom: 20px">
                <span class="step-title">Recherchez le client</span>
              </div>
              <div class="form-group" [ngClass]="{'disabledbutton': isHistoLoc}">
                <div *ngIf="param.clientDemandeurEcoloc" class="text-underline uppercase text"
                  style="margin-bottom: 15px;" (click)=" showComboDemandeur()">
                  <span>Client demandeur</span>
                </div>
                <app-autocomplete *ngIf="!planning.showcombo"
                  [placeholder]="isEdit? eventSelected.detail.client.nomClient :'Nom et prénom du client *'"
                  (searchfunction)="objectFocus.client = true; searchClient($event)"
                  (selectfunction)="setValuePlanning($event, 'client')" id="autoClt" [results]="dataClient"
                  [label]="'Nom et prénom du client *'"
                  [defaultsearch]="planning.client ? planning.client.libelleObjetEntite : ''" [minlength]="3">
                </app-autocomplete>
                <div *ngIf="planning.showcombo">
                  <div class="list-group">
                    <a class="list-group-item container" tabindex="0"
                      (keyup)="changeFocus($event, i, planning.showInfos)" (keyup.enter)="focusNextClt(false)">
                      <input type="radio" id="s-option" name="showInfo" value="false"
                        [checked]="planning.showInfos === false">
                      <span class="text" style="padding-left: 15px;">NON</span>
                      <span class="checkmark"></span>
                    </a>
                    <a class="list-group-item container" tabindex="1"
                      (keyup)="changeFocus($event, i, planning.showInfos)" (keyup.enter)="focusNextClt(true)">
                      <input type="radio" id="s-option" name="showInfo" value="true"
                        [checked]="planning.showInfos === true">
                      <span class="text" style="padding-left: 15px;">OUI</span>
                      <span class="checkmark"></span>
                    </a>
                  </div>
                  <div style="margin: 15px 0px">
                    <app-autocomplete
                      [placeholder]="(planning.clientDemandeur)? planning.clientDemandeur.libelleObjetEntite :'Nom et prénom du client demandeur *'"
                      (searchfunction)="searchClient($event)"
                      (selectfunction)="setValuePlanning($event, 'clientDemandeur')" [results]="dataClient"
                      [label]="'Nom et prénom du client demandeur *'" (keyenterfunction)="setValuePlanning($event)"
                      [id]="'clientdmd'" [minlength]="3"></app-autocomplete>
                  </div>
                  <app-autocomplete
                    [placeholder]="isEdit? eventSelected.detail.client.nomClient :'Nom et prénom du client *'"
                    (searchfunction)="searchClient($event)" (selectfunction)="setValuePlanning($event, 'client')"
                    [results]="dataClient" [label]="'Nom et prénom du client *'" [id]="'client1'" [minlength]="3">
                  </app-autocomplete>
                </div>
              </div>
              <label class="text" style=" margin-top: 15px;padding-left: 0px;"
                [ngClass]="{'disabledbutton': isHistoLoc}"
                [ngStyle]="{'margin-top': objectFocus.client ? '170px' : '15px'}"
                (click)="showFicheCltadd()">Voulez-vous
                <span class='text-underline uppercase'>creer un Client</span> ?</label>
              <div class="uppercase col-sm-12" style="padding: 0"
                [ngStyle]="{'margin': planning.showcombo ? '20px 0px 0' : '80px 0px 0'}">
                <button class="btn-ok"
                  (click)="planning.client ? nextStepClient() : setValuePlanning($event, 'client')">
                  OK
                </button>
                <label>Appuyez sur
                  <b>Entrée</b> pour valider.</label>
              </div>
            </div>
            <div *ngSwitchCase="2" class="etape2">
              <div style="margin-bottom: 15px">
                <span class="step-title">Sélectionnez le chantier</span>
              </div>
              <label class="text form-group col-sm-12 p-0" style=" margin-top: 15px;padding-left: 0px;"
                [ngClass]="{'disabledbutton': isEdit}" (click)="showHistoPrest()">
                <span class='text-underline uppercase'>Histo des prestations du client</span> </label>

              <div class="form-group col-sm-12 p-0" [ngClass]="{'disabledbutton': isHistoLoc}">
                <app-autocomplete [placeholder]="isEdit? eventSelected.detail.chantier.numChantier :'Chantier *'"
                  (searchfunction)="searchChantier($event)" (selectfunction)="setValuePlanning($event, 'chantier')"
                  [results]="listChantier" [label]="'Chantier *'" id="autoCht"
                  [defaultsearch]="selectedChantier ? selectedChantier.numChantier : ''" [autoshow]="true">
                </app-autocomplete>
                <label class="text" style=" margin-top: 190px;padding-left: 0px;"
                  (click)="getChantier(false)">Voulez-vous
                  <span class='text-underline uppercase'>creer un chantier</span> ?</label>
              </div>

              <div class="uppercase col-sm-12" style="margin: 5px 0px;     padding: 0;">
                <button class="btn-ok" (click)="setValuePlanning(selectedChantier, 'chantier')">
                  OK
                </button>
                <label>Appuyez sur
                  <b>Entrée</b> pour valider.</label>
              </div>
            </div>
            <div *ngSwitchCase="3" class="etape3">
              <div style="margin-bottom: 15px">
                <span class="step-title">Vérifier l'adresse du chantier</span>
              </div>
              <div class="list-group">
                <li class="list-group-item container selected-item" id="autofocus" tabindex="0" *ngIf="selectedChantier"
                  (click)="setValuePlanning('test', 'adresse')" (keyup.enter)="setValuePlanning('test', 'adresse')"
                  style="height: auto;">
                  <input type="radio" class="col-sm-1" name="adresse" checked="checked" value="item">
                  <span *ngIf="!isEdit" class="col-sm-12">
                    <div> {{selectedChantier.numChantier || ''}} </div>
                    <div> {{selectedChantier.complementAdresse1 || ''}} </div>
                    <div> {{selectedChantier.complementAdresse2 || ''}} </div>
                    <div> {{selectedChantier.adresse1 || ''}} </div>
                    <div> {{selectedChantier.adresse2 || ''}} </div>
                    <div> {{selectedChantier.adresse3 || ''}} </div>
                    <div> {{ (selectedChantier.codePostal || '') + ' ' + (selectedChantier.ville ||
                      '') }} </div>
                    <div> {{ (selectedChantier.telephone || '') }} </div>
                  </span>
                  <span *ngIf="isEdit" class="col-sm-12">
                    <div> {{eventSelected.detail.chantier.numChantier || ''}} </div>
                    <div> {{eventSelected.detail.chantier.complementAdresse1 || ''}} </div>
                    <div> {{eventSelected.detail.chantier.complementAdresse2 || ''}} </div>
                    <div> {{eventSelected.detail.chantier.adresse1 || ''}} </div>
                    <div> {{eventSelected.detail.chantier.adresse2 || ''}} </div>
                    <div> {{eventSelected.detail.chantier.adresse3 || ''}} </div>
                    <div> {{ (eventSelected.detail.chantier.codePostal || '') + ' ' +
                      (eventSelected.detail.chantier.ville
                      || '') }} </div>
                    <div> {{ (eventSelected.detail.chantier.telephone || '')}} </div>
                  </span>
                </li>
              </div>
              <label class="text" style=" margin-top: 15px;padding-left: 0px;"
                [ngClass]="{'disabledbutton': isHistoLoc}"
                (click)="getChantier((isEdit && eventSelected && eventSelected.detail && eventSelected.detail.chantier ? eventSelected.detail.chantier.id : selectedChantier.id), true)">Voulez-vous
                <span class='text-underline uppercase'>modifier l'adresse du chantier</span> ?</label>
              <div class="uppercase" style="margin: 80px 0px;">
                <button class="btn-ok" (click)="setValuePlanning('test', 'adresse')">
                  OK
                </button>
                <label>Appuyez sur
                  <b>Entrée</b> pour valider.</label>
              </div>
            </div>
            <div *ngSwitchCase="3.1" class="etape2">
              <div style="margin-bottom: 15px">
                <span class="step-title">Choix du site </span>
              </div>
              <div class="form-group col-sm-12" style="padding: 0;"
                [ngClass]="{'disabledbutton': (!edit && isMouvPraxy) || param.choixSiteBloque }">
                <app-autocomplete [placeholder]="'Site de prestation'"
                  (searchfunction)="objectFocus.site = true; searchSite($event)" (selectfunction)="planning.sitePrest = $event; defaultSite = $event;
                  planning.showsite = true;common.clickElement('.siteCA', 100)" [results]="listeSiteCA" [highlight]="true"
                  [label]="'Site de prestation :'" [dropdownclass]="mindropdown"  [isCombo]="true"
                  [id]="'sitePrest'" [defaultselected]="defaultSite"
                  [defaultsearch]="defaultSite ? defaultSite.nom : ''"></app-autocomplete>
              </div>

              <div class="form-group col-sm-12" style="padding: 0;"
                [ngClass]="{'disabledbutton': (!edit && isMouvPraxy) || param.choixSiteBloque }">
                <app-autocomplete [placeholder]="'Pour le compte de'"
                  (searchfunction)="objectFocus.site = true; searchSite($event)"
                  (selectfunction)="setValuePlanning($event, 'siteCA');planning.siteCA = $event;  defaultSiteCA = $event; planning.showsite = true;"
                  [results]="listeSiteCA" [highlight]="true" [label]="'Pour le compte de :'"
                  [dropdownclass]="mindropdown" [isCombo]="true" [id]="'siteCA'"
                  [defaultselected]="defaultSiteCA" [defaultsearch]="defaultSiteCA ? defaultSiteCA.nom : ''">
                </app-autocomplete>
              </div>

              <div class="uppercase col-sm-12" style="margin: 185px 0px 0px;padding: 0;"
                [ngStyle]="{'margin-top': objectFocus.site ? '185px' : '80px' }">
                <button class="btn-ok"
                  (click)="setValuePlanning(defaultSite, 'sitePrest');planning.siteCA = defaultSiteCA; planning.showsite = true;">
                  OK
                </button>
                <label>Appuyez sur
                  <b>Entrée</b> pour valider.</label>
              </div>
            </div>

            <div *ngSwitchCase="4" class="etape4">
              <div style="margin-bottom: 15px">
                <span class="step-title">Ajoutez une prestation</span>
              </div>

              <div class="form-group" style=" padding: 0;" *ngIf="!planning.multiPrestation"
                [ngClass]="{'col-sm-12': !isQtePrevisionnelle, 'col-sm-8': isQtePrevisionnelle, 'disabledbutton': isHistoLoc}">
                <app-autocomplete [placeholder]="'Nom de la prestation'"
                  (searchfunction)="objectFocus.prestation = true;searchArticle($event)"
                  (selectfunction)="validerChoixComboPrestation($event)" id="autoPresta"
                  [label]="'Nom de la prestation'" [results]="dataArticle"
                  [defaultsearch]="planning.prestation ? planning.prestation.libelleObjetEntite : ''">
                </app-autocomplete>
              </div>

              <div class="form-group col-sm-4" style=" padding: 0;" [ngClass]="{'disabledbutton': isHistoLoc}"
                *ngIf="!planning.multiPrestation && isQtePrevisionnelle">
                <label class="libelleQtePrev"> Qté prév. </label>
                <input autocomplete="off" class="fieldQtePrev" type="number" id="fieldQtePrev"
                  [ngModel]="planning.qtePrevisionnelle"
                  (keydown.enter)="validerChoixPrestation(planning.qtePrevisionnelle || 0)"
                  (ngModelChange)="changerQtePrev($event)">
              </div>

              <label class="text pull-right" style="padding: 0;" [ngClass]="{'disabledbutton': isHistoLoc}"
                [ngStyle]="{'margin-top': objectFocus.prestation ? '170px' : '15px'}" (click)="multiPrestation()">
                <span class='text-underline uppercase'> {{ !planning.multiPrestation ? 'Plusieurs
                  prestations' : 'Une prestation'}} </span>
              </label>

              <div class="form-group col-sm-12 prestation-ecoloc" style="padding: 0; margin-top: 20px;"
                *ngIf="planning.multiPrestation">
                <ngx-datatable style="height: 100%" class="material cubage"
                  [rows]="isEdit ? eventSelected.detail.listPrestation : listpresta" [columnMode]="'force'"
                  [headerHeight]="40" [footerHeight]="0" [rowHeight]="40"
                  [messages]="{emptyMessage: 'Pas de lignes à afficher'}" [loadingIndicator]="loadingIndicator">
                  <ngx-datatable-column name="Article" [width]="150">
                    <ng-template ngx-datatable-header-template let-allRowsSelected="allRowsSelected"
                      let-selectFn="selectFn" let-sort="sortFn">
                      <div class="tableheader">
                        <span class="uppercase"> Article </span>
                      </div>
                    </ng-template>
                    <ng-template let-value="value" let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                      <div class="getID" id="{{rowIndex}}" [ngClass]="{'disabledbutton': isHistoLoc}">
                        <app-autocomplete [placeholder]="row.article ? '' : 'Article'"
                          (searchfunction)="searchArticle($event)"
                          (selectfunction)="selectArticleMultiPrestation($event, row)" [notOblig]="true" [label]="''"
                          [selectvalue]="true" [container]="true" [results]="dataArticle" [id]="'detailfact'"
                          [defaultsearch]="row.id ? (row.libelleObjetEntite ? row.libelleObjetEntite : ((row.code ? row.code + '/' : '') + (row.libelle || ''))) : ''"
                          [autohide]="true" [dropdownclass]="'dropetat'"
                          (keyenterfunction)="common.focusNext('.ligneBon')">
                        </app-autocomplete>
                      </div>
                    </ng-template>
                  </ngx-datatable-column>

                  <ngx-datatable-column name="Exu" [width]="100">
                    <ng-template ngx-datatable-header-template let-allRowsSelected="allRowsSelected"
                      let-selectFn="selectFn" let-sort="sortFn">
                      <div class="tableheader">
                        <span class="uppercase"> Exutoire </span>
                      </div>
                    </ng-template>
                    <ng-template let-value="value" let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                      <div class="getID" id="{{rowIndex}}" [ngClass]="{'disabledbutton': isHistoLoc}">
                        <app-autocomplete [placeholder]="row.exu ? '' : 'Exutoire'"
                          (searchfunction)="searchExutoire($event)"
                          (selectfunction)="selectExutoireMultiPrestation($event, row)" [notOblig]="true" [label]="''"
                          [selectvalue]="true" [container]="true" [results]="dataExutoire" [id]="'detailfact'"
                          [defaultsearch]="row.exu && row.exu.id ? (row.exu.libelleObjetEntite ? row.exu.libelleObjetEntite : (row.exu.nom || '')) : ''"
                          [autohide]="true" [dropdownclass]="'dropetat'"
                          (keyenterfunction)="common.focusNext('.ligneBon')">
                        </app-autocomplete>
                      </div>
                    </ng-template>
                  </ngx-datatable-column>

                  <ngx-datatable-column name="QtePrev" *ngIf="isQtePrevisionnelle" [width]="100">
                    <ng-template ngx-datatable-header-template let-allRowsSelected="allRowsSelected"
                      let-selectFn="selectFn" let-sort="sortFn">
                      <div class="tableheader">
                        <span class="uppercase"> Qté Prév. </span>
                      </div>
                    </ng-template>
                    <ng-template let-value="value" let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                      <input id="axe{{rowIndex}}" type="number" class="form-control"
                        [ngClass]="{'disabledbutton': isHistoLoc}" [(ngModel)]="row.qtePrevisionnelle">
                    </ng-template>
                  </ngx-datatable-column>

                  <ngx-datatable-column [width]="80" [sortable]="false" [canAutoResize]="false" [draggable]="false"
                    [resizeable]="false">
                    <ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-row="row">
                      <div class="text-right" style="padding-right: 5px;" [ngClass]="{'disabledbutton': isHistoLoc}">
                        <button class="btn-detail" (click)="deleteLigneMultiPrestation(row)">
                          <i class="fa fa-trash"></i>
                        </button>
                      </div>
                    </ng-template>
                  </ngx-datatable-column>
                </ngx-datatable>
              </div>

              <label class="text pull-right" style="padding: 0;" *ngIf="planning.multiPrestation"
                [ngClass]="{'disabledbutton': isHistoLoc}">
                <button class="btn-add" (click)="addLigneMultiPrestation()">
                  <i class="fa fa-plus"></i>
                </button>
                &nbsp;<span class='text-underline uppercase'>Ajouter
                  une ligne </span>
              </label>

              <div class="col-sm-12 uppercase" style="margin: 30px 0px 0; padding: 0;">
                <button class="btn-ok" (click)="validerChoixPrestation($event)">
                  OK
                </button>

                <label>Appuyez sur
                  <b>Entrée</b> pour valider.</label>
              </div>
            </div>

            <div *ngSwitchCase="4.1" class="etape4">
              <div style="margin-bottom: 15px">
                <span class="step-title">Choix de l'exutoire </span>
              </div>

              <div class="form-group col-sm-12" style=" padding: 0;" [ngClass]="{'disabledbutton': isHistoLoc}">
                <app-autocomplete [placeholder]="'Exutoire'"
                  (searchfunction)="objectFocus.prestation = true;anotheExutoire($event)"
                  (selectfunction)="planning.exutoire = $event; setValuePlanning($event, 'exutoire');" id="autoExutoire"
                  [label]="'Exutoire'" [results]="listExutoire"
                  [defaultsearch]="planning.exutoire ? (planning.exutoire.nom || planning.exutoire.libelleObjetEntite) : ''"
                  (keyenterfunction)="planning.exutoire = $event ; setValuePlanning($event, 'exutoire')">
                </app-autocomplete>
              </div>


              <div class="col-sm-12 uppercase" style="margin: 30px 0px 0; padding: 0;">
                <button class="btn-ok"
                  (click)="setValuePlanning((planning.exutoire ? planning.exutoire : {id: 0, libelleObjetEntite: ''}), 'exutoire');">
                  OK
                </button>

                <label>Appuyez sur
                  <b>Entrée</b> pour valider.</label>
              </div>
            </div>
            <div *ngSwitchCase="5" class="etape7">
              <div style="margin-bottom: 15px">
                <span class="step-title"> Définissez l'heure de début et de fin </span>
              </div>
              <div class="row">
                <div class="col-sm-12" [ngClass]="{'disabledbutton': isHistoLoc}">
                  <span class="col-sm-12"> Début :
                    <span style="margin-left: 147px;">{{common.isDate(planning.dateStart)}}</span>
                  </span>
                  <div class="col-sm-12">
                    <app-input-date [class]="'col-sm-6 date'" [id]="'date1'"  [model]="planning.dateStart"
                      (changefct)="planning.dateStart = $event;recalculDateRapel();" [placeholder]="'Date debut'"
                      (blurfct)=" calculDate();changeDatePlanning('dateStart')"
                      (keyenterfct)="common.changeDate($event, planning.dateStart, '#h1'); recalculDateRapel()"
                      (selectfct)="selectDate($event, '#date1'); recalculDateRapel()" [showDatepicker]="true">
                    </app-input-date>

                    <input type="text" class="col-sm-2  col-sm-offset-1 inputtime" id="h1" placeholder="HH"
                      (focus)="closeAll(d, d2);" [(ngModel)]="planning.hourStart" (keydown.enter)="common.focusElement('#mm1')"
                      [ngClass]="{'inputtime-valid': planning.hourStart && planning.hourStart.length == 2}"
                      autocomplete="off">

                    <input type="text" class="inputtime col-sm-2 col-sm-offset-1" placeholder="MM" id="mm1"
                      (focus)="closeAll(d, d2)" [(ngModel)]="planning.minStart" (ngModelChange)="changeHeureDebut()"
                      (keydown.enter)="common.focusElement('#date2')"
                      [ngClass]="{'inputtime-valid':planning.minStart && planning.minStart.length == 2}"
                      autocomplete="off" (blur)="calculHour()">
                    <app-input-date style="position: relative; top: 30px;" 
                      [class]="'col-sm-6 date' + (common.getDiffDate(planning.dateStart, planning.dateEnd, false, true) < 0 ? ' error' : '')"
                      [id]="'date2'" [model]="planning.dateEnd"
                      (changefct)="planning.dateEnd = $event; planning.changeEnd = true;" [placeholder]="'Date fin'"
                      (blurfct)=" changeDatePlanning('dateEnd')"
                      (keyenterfct)="common.changeDate($event, planning.dateEnd, '#h2')"
                      (selectfct)="planning.changeEnd = true;selectDate($event, '#date2')" [showDatepicker]="true">
                    </app-input-date>

                    <input type="text" class="inputtime col-sm-2 col-sm-offset-1" id="h2" placeholder="HH"
                      (focus)="closeAll(d, d2)" [(ngModel)]="planning.hourEnd" style="margin-top: 30px"
                      [ngClass]="{'inputtime-valid':planning.hourEnd && planning.hourEnd.length == 2, 'error': common.getDiffDate(planning.dateStart, planning.dateEnd, false, true) === 0 && testHour() < 0 }"
                      (keydown.enter)="common.focusElement('#mm2')" autocomplete="off">

                    <input type="text" class="inputtime col-sm-2 col-sm-offset-1"  id="mm2" placeholder="MM"
                      (focus)="closeAll(d, d2)" [(ngModel)]="planning.minEnd" style="margin-top: 30px"
                      [ngClass]="{'inputtime-valid':planning.minEnd && planning.minEnd.length == 2,  'error': common.getDiffDate(planning.dateStart, planning.dateEnd, false, true) === 0 && testHour() < 0 }"
                      (keydown.enter)="setValuePlanning($event, 'showDate')" autocomplete="off">
                  </div>
                </div>

                <div class="col-sm-12" style="position: relative; bottom: 70px;">
                  <span class="col-sm-12"> Fin :
                    <span style="margin-left: 167px;">{{common.isDate(planning.dateEnd)}}</span>
                  </span>
                </div>
                <div class="col-sm-12 msgerror">
                  <div class="col-sm-12"
                    *ngIf="common.getDiffDate(planning.dateStart, planning.dateEnd, false, true) < 0">
                    La date de début est supérieur à la date de fin
                  </div>
                  <div class="col-sm-12"
                    *ngIf="common.getDiffDate(planning.dateStart, planning.dateEnd, false, true) === 0 && testHour() < 0">
                    L'heure de début est supérieure à l'heure de fin
                  </div>
                </div>

                <div class="form-group col-sm-12" style="padding: 0 30px; margin-bottom: 15px;"
                  [ngClass]="{'disabledbutton': isHistoLoc}">
                  <input type="checkbox" id="checkbox-1-1 " class="regular-checkbox regular-checkbox-checked prestProg"
                    [(ngModel)]="planning.program" (ngModelChange)="changeProgram();">
                  <span (click)="planning.program = !planning.program; changeProgram();" style="cursor: pointer;">
                    Prestation programmée </span>
                </div>
                <div class="form-group col-sm-12" style="padding: 0 30px; margin-bottom: 15px;">
                  <label class="text" style="padding-left: 0px;" (click)="showProgrammation()">
                    <span class='text-underline uppercase'> Définir les paramètres </span></label>
                </div>

                <div *ngIf="user.personnel && user.personnel.id > 0" class="col-sm-12" style="margin-bottom: 10px;"
                  [ngClass]="{'disabledbutton': isHistoLoc}">
                  <span class="col-sm-12 text-underline uppercase rappel" (click)="showRappel()">
                    Rappel
                    <span *ngIf="isEdit && eventSelected.detail.rappelActif">:
                      {{eventSelected.detail.rappel}}</span>
                  </span>
                </div>
                <div class="col-sm-12 rappels" [ngClass]="{'disabledbutton': isHistoLoc}"
                  *ngIf="planning.showRappel || (isEdit && eventSelected.detail.rappelActif)"
                  style="margin-bottom: 10px;">
                  <div class="col-sm-12" [ngClass]="{'disabledbutton': planning.israppelLibre}">
                    <app-autocomplete [placeholder]="'rappel'" 
                      (selectfunction)="selected=$event; selectRappel($event)" [results]="rappel"
                      [highlight]="true" [label]="''" [selectvalue]="true" [isCombo]="true" [id]="'rappel'"
                      [defaultselected]="selected"
                      [defaultsearch]="selected ? (selected.libelleObjetEntite || selected.libelle) : 'Aucun'">
                    </app-autocomplete>

                    <!-- <div class="btn-group col-sm-12" dropdown style="padding:0px" [isOpen]="status.isopen"
                      (isOpenChange)="change($event)">
                      <button dropdownToggle type="button" class="" style="text-align: left;"
                        [ngClass]="{'input-focus': status.isopen}" [disabled]="planning.israppelLibre">
                        {{planning.rappel.libelleObjetEntite}}
                      </button>
                      <ul *dropdownMenu class="dropdown-menu" role="menu" style="width:100%;height: 215px;">
                        <li role="menuitem" *ngFor="let item of rappel; let i = index;"
                          (click)="selected = item; selectRappel(item, $event)" tabindex="{{i}}"
                          [ngClass]="{'selected': (item.id === selected.id)}" (keyup)="changerappelFocus($event, i)"
                          (keyup.enter)="selected = item; selectRappel(item, $event);">
                          <a class="dropdown-item">{{item.libelleObjetEntite}}</a>
                        </li>
                      </ul>
                    </div> -->
                  </div>
                  <div class="col-sm-12" style="margin-top: 10px;">
                    <div class="col-sm-3" style="padding: 12px 0px 0px 0px;">
                      <input type="checkbox" id="checkbox-1-1 " class="regular-checkbox regular-checkbox-checked"
                        [(ngModel)]="planning.israppelLibre" (change)="changeRappelLibre($event)">
                      <span>Libre</span>
                    </div>
                    <div class="col-sm-4">
                      <input type="text" class="form-control" placeholder="0" [onReturn]
                        [(ngModel)]="planning.rappelLibreValeur" (ngModelChange)="rappelLibreChange()"
                        style="padding: 6px 12px;" [disabled]="!planning.israppelLibre" autocomplete="off">
                    </div>
                    <div class="col-sm-5" style="padding: 0px">
                      <select class="form-control select" name="site" [(ngModel)]="planning.rappelLibre"
                        (ngModelChange)="rappelLibreChange()" style="padding: 6px 12px;"
                        [disabled]="!planning.israppelLibre">
                        <option *ngFor="let item of typerappel" [ngValue]="item"> {{
                          item.libelleObjetEntite }} </option>
                      </select>
                    </div>
                  </div>
                </div>

                <div class="col-sm-12" *ngIf="param.periodeEcoloc" [ngClass]="{'disabledbutton': isHistoLoc}">
                  <span class="col-sm-12"> Période :</span>
                  <div class="col-sm-12">
                    <app-autocomplete [placeholder]="'periode'" (searchfunction)="objectFocus.periode = true;"
                      (selectfunction)="planning.periode=$event; defaultPeriode = $event" [results]="listPeriode"
                      [highlight]="true" [label]="'Période'" [selectvalue]="true" [isCombo]="true" [id]="'periode'"
                      [defaultselected]="defaultPeriode"
                      [defaultsearch]="defaultPeriode ? (defaultPeriode.libelleObjetEntite || defaultPeriode.libelle) : ''">
                    </app-autocomplete>
                  </div>
                </div>

                <div class="form-group col-sm-12" style="padding: 0 30px; margin-bottom: 15px; margin-top: 15px;"
                  [ngClass]="{'disabledbutton': isHistoLoc}">
                  <input type="checkbox" id="checkbox-1-1 "
                    class="regular-checkbox regular-checkbox-checked prestPlusInput"
                    [(ngModel)]="planning.checkPlusieursLocations" (ngModelChange)="showPlusPrest();">
                  <span (click)="planning.checkPlusieursLocations = !planning.checkPlusieursLocations; showPlusPrest();"
                    style="cursor: pointer;">
                    Plus Prest. </span>
                </div>
                <div class="form-group col-sm-12" style="padding: 0 30px; margin-bottom: 15px;"
                  [ngClass]="{'disabledbutton': isHistoLoc}">
                  <label class="text" style="padding-left: 0px;" (click)="showPlusPrest()">
                    <span class='text-underline uppercase'> Voir les prestations </span></label>
                </div>

                <div class="uppercase col-sm-12" style="margin: 5px 15px;;">
                  <button class="btn-ok"
                    (click)="(common.getDiffDate(planning.dateStart, planning.dateEnd, false, true) < 0 || common.getDiffDate(planning.dateStart, planning.dateEnd, false, true) === 0 && testHour() < 0) ? false : setValuePlanning($event, 'showDate')">
                    OK</button>
                  <label> Appuyez sur
                    <b> Entrée </b> pour valider. </label>
                </div>
              </div>
            </div>
            <div *ngSwitchCase="6" class="etape5">
              <div style="margin-bottom: 15px">
                <span class="step-title">Ajoutez une machine</span>
              </div>

              <div class="form-group" [ngClass]="{'disabledbutton': isHistoLoc}">
                <app-autocomplete *ngIf="!planning.multiCamion"
                  [placeholder]="isEdit ? (eventSelected.detail.camion ? eventSelected.detail.camion.immatriculation : 'Nom ou identifiant de la machine *') :'Nom ou identifiant de la machine *'"
                  (searchfunction)="objectFocus.camion=true;searchCamion($event)"
                  (selectfunction)="setValuePlanning($event, 'machine')"
                  [defaultsearch]="planning.machine ? (planning.machine.libelleEdit || planning.machine.libelleObjetEntite) : ''"
                  id="autoMat" [label]="'Nom ou identifiant de la machine *'" [results]="dataCamion"
                  (keyenterfunction)="setValuePlanning($event)"></app-autocomplete>
              </div>


              <label class="text pull-right" style="padding: 0;" [ngClass]="{'disabledbutton': isHistoLoc}"
                [ngStyle]="{'margin-top': objectFocus.prestation ? '170px' : '15px'}" (click)="multiCamion()">
                <span class='text-underline uppercase'> {{ !planning.multiCamion ? 'Plusieurs
                  machines' : 'Une machine'}} </span>
              </label>

              <div class="form-group col-sm-12 prestation-ecoloc" style="padding: 0; margin-top: 20px;"
                *ngIf="planning.multiCamion">
                <ngx-datatable style="height: 100%" class="material cubage"
                  [rows]="isEdit ? eventSelected.detail.listMateriel : listMateriel" [columnMode]="'force'"
                  [headerHeight]="40" [footerHeight]="0" [rowHeight]="40"
                  [messages]="{emptyMessage: 'Pas de lignes à afficher'}" [loadingIndicator]="loadingIndicator">
                  <ngx-datatable-column name="Article" [width]="150">
                    <ng-template ngx-datatable-header-template let-allRowsSelected="allRowsSelected"
                      let-selectFn="selectFn" let-sort="sortFn">
                      <div class="tableheader">
                        <span class="uppercase"> Machine </span>
                      </div>
                    </ng-template>
                    <ng-template let-value="value" let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                      <div class="getID" id="{{rowIndex}}" [ngClass]="{'disabledbutton': isHistoLoc}">
                        <app-autocomplete [placeholder]="row.article ? '' : 'Machine'"
                          (searchfunction)="searchCamion($event)"
                          (selectfunction)="selectCamionMultiCamion($event, row)" [notOblig]="true" [label]="''"
                          [selectvalue]="true" [container]="true" [results]="dataCamion" [id]="'detailfact'"
                          [defaultsearch]="row.id ? row.libelleObjetEntite : ''" [autohide]="true"
                          [dropdownclass]="'dropetat'" (keyenterfunction)="common.focusNext('.ligneBon')">
                        </app-autocomplete>
                      </div>
                    </ng-template>
                  </ngx-datatable-column>

                  <ngx-datatable-column [width]="80" [sortable]="false" [canAutoResize]="false" [draggable]="false"
                    [resizeable]="false">
                    <ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-row="row">
                      <div class="text-right" style="padding-right: 5px;" [ngClass]="{'disabledbutton': isHistoLoc}">
                        <button class="btn-detail" (click)="deleteLigneMultiCamion(row)">
                          <i class="fa fa-trash"></i>
                        </button>
                      </div>
                    </ng-template>
                  </ngx-datatable-column>
                </ngx-datatable>
              </div>

              <label class="text pull-right" style="padding: 0;" *ngIf="planning.multiCamion"
                [ngClass]="{'disabledbutton': isHistoLoc}">
                <button class="btn-add" (click)="addLigneMultiCamion()">
                  <i class="fa fa-plus"></i>
                </button>
                &nbsp;<span class='text-underline uppercase'>Ajouter
                  une ligne </span>
              </label>

              <div class="uppercase col-sm-12" style="margin: 80px 0px 0px; padding: 0px;"
                [ngStyle]="{'margin-top': objectFocus.camion ? '180px' : '80px'}">
                <button class="btn-ok" (click)="validerChoixMateriel($event)">
                  OK
                </button>
                <label>Appuyez sur
                  <b>Entrée</b> pour valider.</label>
              </div>
            </div>

            <div *ngSwitchCase="7" class="etape6">
              <div style="margin-bottom: 15px" *ngIf="!planning.isPartenaire">
                <span class="step-title"> Affectez des personnes supplémentaires </span>
              </div>
              <div class="row" *ngIf="!planning.isPartenaire">
                <div class="col-sm-12" style="height:auto;margin-bottom: 30px;" *ngIf="!isEdit && param.ecolocEquipe">
                  <button class="btn btn-equipes" *ngFor="let prs of equipes;  let first = first; let index = index;">
                    <span *ngIf="!prs || (prs && !prs.id)"> {{ (first ? 'Aucun (Leader)' : 'A définir') }} </span>
                    <span *ngIf="prs && prs.id"> {{prs.matricle || ''}}
                      {{(prs.nom || '') + (prs.prenom || '') + (first ? ' (Leader)' : '')}} </span>
                  </button>
                </div>
                <div class="col-sm-12" style="height:auto;margin-bottom: 30px;" *ngIf="isEdit && param.ecolocEquipe">
                  <button class="btn btn-equipes"
                    *ngIf="eventSelected.detail.chauffeur && eventSelected.detail.chauffeur.id && eventSelected.detail.chauffeur.id !== 0">
                    {{eventSelected.detail.chauffeur.matricule || ''}}
                    {{((eventSelected.detail.chauffeur.nom || '') + ' ' +
                    (eventSelected.detail.chauffeur.prenom || '') + ' (Leader)')}}
                  </button>
                  <button class="btn btn-equipes"
                    *ngIf="eventSelected.detail.chauffeur && !eventSelected.detail.chauffeur.id">
                    A définir (Leader)
                  </button>
                  <ng-template ngFor let-prs [ngForOf]="eventSelected.detail.listePersonnelParPoste">
                    <button class="btn btn-equipes"
                      *ngIf="!prs.chauffeur || (prs.chauffeur && !prs.chauffeur.posteSupprime)">
                      <span *ngIf="!prs.chauffeur || (prs.chauffeur && !prs.chauffeur.id)"> A
                        définir </span>
                      <span *ngIf="prs.chauffeur && prs.chauffeur.id">
                        {{prs.chauffeur ? prs.chauffeur.matricule : ''}} {{ ((prs.chauffeur ?
                        (prs.chauffeur.nom || '') : '') + ' ' +
                        (prs.chauffeur ? prs.chauffeur.prenom : ''))}}
                      </span>
                    </button>
                  </ng-template>

                </div>

                <br *ngIf="param.ecolocEquipe" />
                <div class="form-group col-sm-12" *ngIf="!param.ecolocEquipe">
                  <app-autocomplete [placeholder]="'Nom de la personne à ajouter'"
                    (searchfunction)="objectFocus.chauffeur=true;searchChauffeurEcolocEquipeFalse($event)"
                    (selectfunction)="addEquipe($event);setValuePlanning($event, 'chauffeur')" id="autoPrs"
                    [defaultsearch]="afficheLeader()" [label]="'Nom de la personne à ajouter'" [results]="dataChauffeur"
                    (keyenterfunction)="setValuePlanning($event, 'chauffeur');"></app-autocomplete>
                </div>

                <div class="form-group col-sm-12" style="margin-bottom: 15px;" *ngIf="param.ecolocEquipe">
                  <div class="col-sm-6" style="padding: 0;">
                  </div>
                  <label class="col-sm-6 text text-right" style="padding-left: 0px;" (click)="showEquipeFct()">
                    <span class='text-underline uppercase'> Modifier l'équipe </span></label>
                </div>

              </div>
              <div class="uppercase col-sm-12" style="margin: 20px 0px 0; padding: 0px" *ngIf="!planning.isPartenaire"
                [ngStyle]="{'margin-top': objectFocus.chauffeur ? '180px' : '20px'}">
                <button class="btn-ok"
                  (click)="setValuePlanning($event.title); planning.isPartenaire = param.gestionCQC ? true : false;"> OK
                </button>
                <label>Appuyez sur
                  <b>Entrée</b> pour valider.</label>
              </div>


              <!-- Choix du partenaire-->
              <div style="margin-bottom: 15px" *ngIf="planning.isPartenaire">
                <span class="step-title"> Choix du partenaire </span>
              </div>
              <div class="row" *ngIf="planning.isPartenaire">
                <div class="form-group col-sm-12" [ngClass]="{'disabledbutton': isHistoLoc}">
                  <app-autocomplete [placeholder]="'Nom de la personne à ajouter'"
                    (searchfunction)="objectFocus.partenaire=true;searchChauffeurSousTraitant($event)"
                    (selectfunction)="setValuePlanning($event, 'partenaire')" id="autoPrs"
                    [defaultsearch]="planning.partenaire ? (planning.partenaire.libelleObjetEntite || planning.partenaire.nom) : ''"
                    [label]="'Nom de la personne à ajouter'" [results]="dataChauffeur"
                    (keyenterfunction)="setValuePlanning($event, 'partenaire')"></app-autocomplete>
                </div>
              </div>
              <div class="uppercase col-sm-12" style="margin: 20px 0px; padding: 0px;" *ngIf="planning.isPartenaire"
                [ngStyle]="{'margin-top': objectFocus.partenaire ? '170px' : '20px'}">
                <button class="btn-ok" (click)="setValuePlanning($event, 'partenaire')"> OK
                </button>
                <label>Appuyez sur
                  <b>Entrée</b> pour valider.</label>
              </div>
            </div>

            <div *ngSwitchCase="7.1" class="etape5">
              <div style="margin-bottom: 15px">
                <span class="step-title">Facturation</span>
              </div>
              <div class="form-group" [ngClass]="{'disabledbutton': isHistoLoc}">
                <div class="form-group  col-sm-12 p-0" style="position: relative;">
                  <div class="col-sm-4 p-0" style="padding-top: 10px !important;">
                    <mat-checkbox [color]="'primary'" [(ngModel)]="planning.isAcompte">
                      Acompte</mat-checkbox>
                  </div>
                  <div class="col-sm-8 p-0">
                    <label *ngIf="planning.acomptefocus || planning.acompte"
                      style="position: absolute; top: -2px;font-size: 11px; text-align: left;padding-left: 8px;">
                      Montant </label>
                    <input type="number" step="0.01" class="form-control info" id="acompte" autofocus
                      placeholder="Montant" [(ngModel)]="planning.acompte" (keyup.enter)="common.focusNext('.divers')"
                      [ngClass]="{'noValue': !planning.acomptefocus && !planning.acompte}" style="padding: 8px 8px 0px;"
                      (focus)="planning.acomptefocus = true;" (blur)="planning.acomptefocus = false;" autocomplete="off"
                      [disabled]="!planning.isAcompte">
                  </div>
                </div>
                <div class="form-group col-sm-12 p-0" style="position: relative;">
                  <div class="col-sm-4 p-0" style="padding-top: 10px !important;" [ngClass]="{'disabledbutton': eventSelected && eventSelected.detail &&
                  eventSelected.detail.contrat && eventSelected.detail.contrat.id > 0}">
                    <mat-checkbox [color]="'primary'" [(ngModel)]="planning.isContrat">Contrat</mat-checkbox>
                  </div>
                  <div class="col-sm-8 p-0">
                    <label *ngIf="planning.contratfocus || planning.numContrat"
                      style="position: absolute; top: -2px;font-size: 11px; text-align: left;padding-left: 8px;">
                      Référence </label>
                    <input type="text" class="form-control info" id="contrat" placeholder="Référence"
                      [(ngModel)]="planning.numContrat" (keyup.enter)="common.focusNext('.divers')" [ngClass]="{'noValue': !planning.contratfocus && !planning.numContrat,
                      'numContratRouge disabledbutton': eventSelected && eventSelected.detail &&
                      eventSelected.detail.contrat && eventSelected.detail.contrat.id > 0}"
                      style="padding: 8px 8px 0px;" (focus)="planning.contratfocus = true;"
                      (blur)="planning.contratfocus = false;" autocomplete="off" [disabled]="!planning.isContrat">
                  </div>
                </div>
              </div>
              <div class="uppercase col-sm-12" style="margin: 80px 0px 0px; padding: 0px;"
                [ngStyle]="{'margin-top': objectFocus.camion ? '180px' : '80px'}">
                <button class="btn-ok" (click)="setValuePlanning(true, 'facturation')">
                  OK
                </button>
                <label>Appuyez sur
                  <b>Entrée</b> pour valider.</label>
              </div>
            </div>

            <div *ngSwitchCase="8" class="etape8">
              <div style="margin-bottom: 15px">
                <span class="step-title"> Souhaitez vous ajouter des informations de facturation et/ou
                  supplémentaires </span>
              </div>
              <div class="list-group">
                <a class="list-group-item container" tabindex="0" (keyup)="changeFocus($event, i)"
                  (keyup.enter)="isEdit? setValuePlanning($event) :generateBon();"
                  (click)="isEdit? setValuePlanning($event) :generateBon();">
                  <input type="radio" id="s-option" name="showInfo" value="false"
                    [checked]="planning.showInfo === false">
                  <span class="text">NON</span>
                  <span class="checkmark"></span>
                </a>
                <a class="list-group-item container" tabindex="1" (keyup)="changeFocus($event, i)"
                  (keyup.enter)="showInfoSupp(true); nextStep()" (click)="showInfoSupp(true); nextStep()">
                  <input type="radio" id="s-option" name="showInfo" value="true" [checked]="planning.showInfo === true">
                  <span class="text">OUI</span>
                  <span class="checkmark"></span>
                </a>
              </div>
              <div class="row">
                <div class="uppercase col-sm-12" style="margin: 20px 0px;">
                  <button class="btn-ok" (click)="planning.showInfo  ? nextStep() : finFunction($event)">
                    OK
                  </button>
                  <label style="margin-top:10px;"> Appuyez sur
                    <b> Entrée </b> pour valider. </label>
                </div>
              </div>
            </div>
            <div *ngSwitchCase="9" class="etape8">
              <div style="margin-bottom: 15px">
                <span class="step-title"> Souhaitez vous ajouter des informations de facturation et/ou
                  supplémentaires </span>
              </div>

              <div style="height: auto;"
                [ngStyle]="{'height': countRowsInText(planning.infosupp) > 3 ? 'auto' : 'auto'}">
                <div class="form-group" style="position: relative;">
                  <label *ngIf="planning.numBSDDfocus || planning.numBSDD"> N° de BSD manuel
                  </label>
                  <input type="text" class="form-control info" placeholder="N° de BSD manuel" id="numbsdd"
                    [(ngModel)]="planning.numBSDD" (keyup.enter)="common.focusElement('#infofact')"
                    [ngClass]="{'noValue': !planning.numBSDDfocus && !planning.numBSDD}"
                    (focus)="planning.numBSDDfocus = true;" (blur)="planning.numBSDDfocus = false;" autocomplete="off">
                </div>
                <div class="form-group" [ngClass]="{'disabledbutton': isHistoLoc}">
                  <label *ngIf="planning.infofactfocus || planning.infofact"> Infos Fact </label>
                  <input type="text" class="form-control info" placeholder="Infos Fact" autofocus id="infofact"
                    [(ngModel)]="planning.infofact" (keyup.enter)="nextFocus()" (focus)="planning.infofactfocus = true;"
                    (blur)="planning.infofactfocus = false;" autocomplete="off">
                </div>
                <div class="form-group" [ngClass]="{'disabledbutton': isHistoLoc}">
                  <label *ngIf="planning.infosuppfocus || planning.infosupp"> Infos supp </label>
                  <textarea class="form-control" rows="{{countRowsInText(planning.infosupp)}}" id="infosup"
                    placeholder="Infos supp" [(ngModel)]="planning.infosupp" style="height: auto;max-height:300px"
                    (focus)="planning.infosuppfocus = true;" (blur)="planning.infosuppfocus = false;"
                    autocomplete="off"></textarea>
                  <div class="uppercase" style="font-size: 11px; margin-top: 3px;" *ngIf="planning.infosuppfocus">Taper
                    sur TAB
                    <span class="icontab">&#x21B9;</span> pour valider
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="uppercase col-sm-12" style="margin: 20px 0px;">
                  <button class="btn-ok" (click)="isEdit ? setValuePlanning($event) : finFunction($event)">
                    OK
                  </button>
                  <label style="margin-top:10px;"> Appuyez sur
                    <b> Entrée </b> pour valider. </label>
                </div>
              </div>
            </div>
          </div>

        </div>
        <div class="text-left uppercase btn-nav" (click)="nextStep()" style="position: absolute;" *ngIf="!isEdit">
          <img src="assets/images/icons/fleche-suivant.svg" alt="suivant" /> Suivant
        </div>
      </div>
    </div>
  </div>
  <div id="slide-right" [ngClass]="{'edit': isEdit, 'recreate': is_recreate}">
    <div class="col-sm-12" style="margin-bottom:5px;">
      <div dropdown class="col-sm-4 pull-left" style="padding: 0px" *ngIf="isEdit">
        <button type="submit" dropdownToggle class="pull-left btn-close">
          ...
        </button>
        <ul *dropdownMenu class="dropdown-menu menuplus" role="menu" style="padding: 5px;">
          <li role="menuitem">
            <button class="bouton btn-simple" *ngIf="isEdit && (eventSelected.detail && eventSelected.detail.camion && eventSelected.detail.camion.listIndispo &&
            eventSelected.detail.camion.listIndispo.length ? false : true)" (click)="getFormatperso()"> IMPRIMER LE BON
            </button>
          </li>
          <li role="menuitem">
            <button class="bouton btn-simple"
              *ngIf="isEdit && (param.typeContenantEcoloc && param.typeContenantEcoloc.id > 0)"
              (click)="getToutesRsrcBSDDPlanningGeneral()"> IMPRIMER BSD
            </button>
          </li>
          <li role="menuitem">
            <button class="bouton btn-simple" *ngIf="isEdit" (click)="showMessage()"> CONVERSATION
            </button>
          </li>
          <li role="menuitem">
            <button class="bouton btn-simple" *ngIf="isEdit" (click)="showDocument()"> DOCUMENTS
            </button>
          </li>

        </ul>
      </div>
      <div class="col-sm-8 pull-right" style="padding: 0px">
        <button class="pull-right btn-close btn-valider" id="btnvalider" autofocus (click)="openModalConfirme()"
          (keydown.enter)="openModalConfirme()" *ngIf="!isHistoLoc && showBtnvalid"> Valider
        </button>
        <button class="pull-right btn-close" id="closeSlide" (click)="toogleSlide()"> Fermer</button>
      </div>


    </div>
    <div class="col-sm-12">
      <h3 style="padding-left: 10px;font-size: 30px;font-weight: 300;font-family: Roboto-Light;"> {{isEdit ?
        (eventSelected.start | date:'dd MMMM yyyy') : (selectedEvent.start | date:'dd MMMM yyyy') }}</h3>
      <h3 style="padding-left: 13px; font-size: 24px;font-weight: 900;font-family: Roboto-Black;" *ngIf="isEdit">
        Bon de prestation N° {{ eventSelected.detail.bon && eventSelected.detail.bon.numBon || ''}}
      </h3>
      <div class="col-sm-12" *ngIf="isEdit && eventSelected.detail.log">
        <div> Modifiée par : {{ eventSelected.detail.log.user ? ((eventSelected.detail.log.user.prenom || '')
          + ' ' + (eventSelected.detail.log.user.nom
          || '')) : '-' }} </div>
        <div> Le : {{ eventSelected.detail.log.date.slice(0, -9) || '' }} </div>
      </div>
    </div>
    <div class="col-sm-12" style="height: calc(100% - 190px); overflow-y: auto;">
      <div class="col-sm-6" *ngIf="isEdit || planning.client" [ngClass]="{'disabledbutton': is_recreate}"
        style="cursor: pointer; padding-top: 6px;">
        <label> Nom du client </label>
        <div>
          <div class="col-sm-12" style="padding-left: 0px;"> {{ isEdit ?
            eventSelected.detail.client.nomClient : (planning.client.libelleObjetEntite ||
            planning.client.nomClient) }} </div>
          <div class="col-sm-12" style="padding-left: 0px;"> {{ isEdit ?
            (eventSelected.detail && eventSelected.detail.bon && eventSelected.detail.bon.clientDemandeur ?
            eventSelected.detail.bon.clientDemandeur.nomClient
            : (planning.clientDemandeur ? planning.clientDemandeur.libelleObjetEntite : '')) : '' }} </div>

        </div>

      </div>
      <div class="col-sm-6" [ngClass]="{'div': isEdit && !eventSelected.detail.histo}"
        [ngClass]="{'disabledbutton': is_recreate}" *ngIf="isEdit ||planning.chantier"
        (click)="editEvent(eventSelected, 2)">
        <label> Nom du chantier </label>
        <div>
          {{ isEdit ? (eventSelected.detail.chantier ? (eventSelected.detail.chantier.numChantier ||
          eventSelected.detail.chantier.responsable || eventSelected.detail.chantier.ville) : '') :
          (planning.chantier.numChantier || planning.chantier.responsable || planning.chantier.ville) }}
        </div>
      </div>
      <div class="col-sm-12">
        <div class="col-sm-6" style="padding: 0;"><label *ngIf="isEdit"
            class=" text-left uppercase text-underline showfiche" (click)="showFiche()">Voir la
            fiche</label></div>
        <div class="col-sm-6" style="padding: 0;">
          <label *ngIf="isEdit" class=" text-left uppercase text-underline showfiche"
            (click)="getChantier(eventSelected.detail.chantier.id)" style="padding-left: 15px;">Voir la
            fiche</label>
        </div>
      </div>

      <div class="col-sm-12" [ngClass]="{'div': isEdit && !eventSelected.detail.histo, 'disabledbutton': is_recreate}"
        *ngIf="isEdit ||planning.adresse" (click)="editEvent(eventSelected, 3)">
        <label> Adresse </label>
        <div style="margin-bottom: 5px;">
          <span *ngIf="isEdit && eventSelected.detail.chantier">
            {{((eventSelected.detail.chantier.numChantier || '') +
            ((eventSelected.detail.chantier.complementAdresse1 ? ' - ' +
            eventSelected.detail.chantier.complementAdresse1 : '') +
            (eventSelected.detail.chantier.complementAdresse2 ? ' - ' +
            eventSelected.detail.chantier.complementAdresse2 : '')) +
            (eventSelected.detail.chantier.adresse1 ? ' - ' + eventSelected.detail.chantier.adresse1 : '')
            + ' - ' + (eventSelected.detail.chantier.codePostal
            || '') + ' ' + eventSelected.detail.chantier.ville + (eventSelected.detail.chantier.telephone ?
            ' - '
            + eventSelected.detail.chantier.telephone : ''))}}
          </span>
          <span *ngIf="!isEdit">
            {{ ((planning.chantier.numChantier || "") + ((planning.chantier.complementAdresse1 ? ' - ' +
            planning.chantier.complementAdresse1 : '') + (planning.chantier.complementAdresse2 ? ' - ' +
            planning.chantier.complementAdresse2 : '')) +
            (planning.chantier.adresse1 ? ' - ' + planning.chantier.adresse1 : "") + ' - ' +
            (planning.chantier.codePostal || "") + ' ' + (planning.chantier.ville || "") +
            (planning.chantier.telephone
            ? ' - ' + planning.chantier.telephone : '')) }}
          </span>
        </div>
      </div>
      <div class="col-sm-12" style="padding: 0px"
        [ngClass]="{'disabledbutton':(eventSelected && eventSelected.detail && eventSelected.detail.histo) || param.choixSiteBloque }">
        <div class="col-sm-6 div" *ngIf="isShowSite && (isEdit || planning.showsite)"
          (click)="editEvent(eventSelected, 3.1)" [ngClass]="{'divRecreate': is_recreate}">
          <label> Site de prestation </label>
          <div style="margin-bottom: 5px;">
            {{ planning.sitePrest ? planning.sitePrest.nom || planning.sitePrest.libelleObjetEntite : '' }}
          </div>
        </div>
        <div class="col-sm-6 div" *ngIf="isShowSite && (isEdit || planning.showsite)"
          (click)="editEvent(eventSelected, 3.1, '.siteCA')"
          [ngClass]="{'divRecreate': is_recreate,'disabledbutton': param.choixSiteBloque }">
          <label> Pour le compte de </label>
          <div style="margin-bottom: 5px;">
            {{ planning.siteCA ? planning.siteCA.nom || planning.siteCA.libelleObjetEntite : '' }}
          </div>
        </div>
      </div>
      <div class="col-sm-12" style="padding: 0;">
        <div class="col-sm-6"
          [ngClass]="{'div':(isEdit && !eventSelected.detail.histo), 'divRecreate': is_recreate    }"
          *ngIf="isEdit || planning.prestation || (planning.listPrestation && planning.listPrestation.length)"
          (click)="editEvent(eventSelected, 4)">
          <label> Type de prestation </label>
          <div style="margin-bottom: 5px;"
            *ngIf="((isEdit && eventSelected.detail.article)  || planning.prestation) && !planning.multiPrestation">
            {{ isEdit ? (eventSelected.detail.article ? ((eventSelected.detail.article.code ?
            eventSelected.detail.article.code + ' / ' :
            '') + ' ' + (eventSelected.detail.article.libelle || eventSelected.detail.article.libelleObjetEntite || ''))
            : '') :
            planning.prestation.libelleObjetEntite }}
          </div>
          <div style="margin-bottom: 5px;" *ngIf="(isEdit || planning.multiPrestation)">
            <div *ngIf="isEdit && eventSelected.detail.listPrestation">
              <div *ngFor="let prest of eventSelected.detail.listPrestation">
                {{prest.code ? prest.code + ' / ' : ''}} {{prest.libelle || ''}}
              </div>
            </div>
            <div *ngIf="!isEdit && planning.listPrestation">
              <div *ngFor="let prest of planning.listPrestation">
                {{prest.libelleObjetEntite}}
              </div>
            </div>
          </div>
        </div>
        <div class="col-sm-6"
          [ngClass]="{'div':(isEdit && !eventSelected.detail.histo), 'divRecreate': is_recreate    }"
          *ngIf="isQtePrevisionnelle && !planning.multiPrestation && (isEdit || planning.qtePrevisionnelle || planning.qtePrevisionnelleShow)"
          (click)="editEvent(eventSelected, 4)">
          <label> Quantité prévisionnelle </label>
          <div style="margin-bottom: 5px;"
            *ngIf="((isEdit && eventSelected.detail.article && eventSelected.detail.article.qtePrevisionnelle)  || planning.qtePrevisionnelle) && !planning.multiPrestation">
            {{ isEdit ? eventSelected.detail.article.qtePrevisionnelle :
            planning.qtePrevisionnelle }}
          </div>
        </div>
      </div>
      <div class="col-sm-12" style="padding: 0;">
        <div class="col-sm-6"
          [ngClass]="{'div':(isEdit && !eventSelected.detail.histo), 'divRecreate': is_recreate    }"
          *ngIf="isEdit ||planning.exutoire" (click)="editEvent(eventSelected, 4.1)">
          <label> Exutoire </label>
          <div style="margin-bottom: 5px;">
            {{ isEdit ? (eventSelected.detail.exutoire && eventSelected.detail.exutoire.id ? (
            eventSelected.detail.exutoire.libelleEdit || eventSelected.detail.exutoire.nom || '') : '') :
            planning.exutoire.libelleObjetEntite }}
          </div>
        </div>
        <div class="col-sm-6"
          [ngClass]="{'div':(isEdit && !eventSelected.detail.histo), 'divRecreate': is_recreate    }"
          *ngIf="isEdit || (planning.program || planning.programation)"
          (click)="editEvent(eventSelected, 5, 'prestProg')">
          <label> Prestation programmée </label>
          <div style="margin-bottom: 5px;">
            {{ planning.program ? 'OUI' : 'NON' }}
          </div>
        </div>
      </div>

      <div class="col-sm-6" [ngClass]="{'div':(isEdit && !eventSelected.detail.histo), 'divRecreate': is_recreate    }"
        *ngIf="isEdit" (click)="editEvent(eventSelected, 5, 'prestPlusInput')">
        <label> Plus Prest. </label>
        <div style="margin-bottom: 5px;">
          {{ planning.checkPlusieursLocations ? 'OUI' : 'NON' }}
        </div>
      </div>

      <div
        *ngIf="isEdit || ((planning.hourStart && planning.minStart) &&(planning.hourStart.length == 2 && planning.minStart.length == 2)) && ((planning.hourEnd && planning.minEnd) && (planning.hourEnd.length == 2 && planning.minEnd.length == 2))"
        class="col-sm-12" style="    padding: 0;">
        <div class="col-sm-6" (click)="editEvent(eventSelected, 5)"
          [ngClass]="{'div':(isEdit && !eventSelected.detail.histo), 'divRecreate': is_recreate    }">
          <label> Début </label>
          <div style="margin-bottom: 5px;"> {{ isEdit ? (eventSelected.detail.dateDebut + ' ' +
            eventSelected.detail.heureDebut.slice(0, -3).replace(':',
            'h')) : ((common.isDateElem(planning.dateStart) ? (planning.dateStart | date : 'dd/MM/yyyy') :
            '') + ' ' + (planning.hourStart + 'h' +
            planning.minStart))
            }} </div>
        </div>
        <div class="col-sm-6" (click)="editEvent(eventSelected, 5, 'date2')"
          [ngClass]="{'div':(isEdit && !eventSelected.detail.histo), 'divRecreate': is_recreate    }">
          <label> Fin </label>
          <div style="margin-bottom: 5px;"> {{ isEdit ? (eventSelected.detail.dateFin + ' ' +
            eventSelected.detail.heureFin.slice(0, -3).replace(':',
            'h')) : ((common.isDateElem(planning.dateEnd) ? (planning.dateEnd | date : 'dd/MM/yyyy') : '') +
            ' ' + (planning.hourEnd + 'h' +
            planning.minEnd))
            }} </div>
        </div>
      </div>
      <div class="col-sm-12" style="    padding: 0;" *ngIf="param.periodeEcoloc && (isEdit || (planning.showDate))">
        <div class="col-sm-6" (click)="editEvent(eventSelected, 5, 'periode')"
          [ngClass]="{'div':(isEdit && !eventSelected.detail.histo), 'divRecreate': is_recreate    }">
          <label> Période </label>
          <div style="margin-bottom: 5px;">
            {{ planning.periode ? (planning.periode.libelleObjetEntite || planning.periode.libelle) : '' }}
          </div>
        </div>

      </div>

      <div class="col-sm-6" [ngClass]="{'div':(isEdit && !eventSelected.detail.histo), 'divRecreate': is_recreate    }"
        *ngIf="isEdit ||planning.machine" (click)="editEvent(eventSelected, 6)">
        <label> Machine </label>

        <div style="margin-bottom: 5px;" [innerHTML]="getTextAffichageMachine()">
          <!--
          {{ isEdit ? (eventSelected.detail.camion && eventSelected.detail.camion.id ? (
          eventSelected.detail.camion.libelleEdit ? eventSelected.detail.camion.libelleEdit
          : ((eventSelected.detail.camion.numParc || '') + ' / ' +
          (eventSelected.detail.camion.immatriculation
          || ''))) : '-') : planning.machine.libelleObjetEntite }}
          -->
        </div>

      </div>

      <div class="col-sm-12" [ngClass]="{'div':(isEdit && !eventSelected.detail.histo), 'divRecreate': is_recreate    }"
        *ngIf="isEdit ||showEquipe" style="padding-bottom: 8px;"
        (click)="planning.isPartenaire = false;editEvent(eventSelected, 7)">
        <label> Equipe </label>
        <div class="col-sm-12">
          <div class="" *ngFor="let prs of equipes; let first = first;">
            <div class="row" *ngIf="prs">
              <div class="col-sm-1" style="padding:0px">
                <img src="assets/images/icons/avatar-default.svg" alt="avatar" />
              </div>
              <div class="col-sm-11" style="padding: 5px 0px;">
                <span *ngIf="prs && prs.id"> {{ (prs.nom || '') + ' ' + (prs.prenom || '')}} </span>
                <span *ngIf="!prs || (prs && !prs.id)"> A définir </span>
                {{ (first ? ' (Leader)' : '')
                }}
              </div>
            </div>
          </div>
          <div class="" *ngIf="isEdit">
            <div class="row"
              *ngIf="eventSelected.detail.chauffeur && eventSelected.detail.chauffeur.id && eventSelected.detail.chauffeur.id !== 0">
              <div class="col-sm-1" style="padding:0px">
                <img src="assets/images/icons/avatar-default.svg" alt="avatar" />
              </div>
              <div class="col-sm-11" style="padding: 5px 0px;"> {{
                ((eventSelected.detail.chauffeur.nom || '') + ' ' + (eventSelected.detail.chauffeur.prenom || '')
                + '
                (Leader)') }} </div>
            </div>
            <div class="row" *ngIf="eventSelected.detail.chauffeur && !eventSelected.detail.chauffeur.id">
              <div class="col-sm-1" style="padding:0px">
                <img src="assets/images/icons/avatar-default.svg" alt="avatar" />
              </div>
              <div class="col-sm-11" style="padding: 5px 0px;"> A définir (Leader) </div>
            </div>
          </div>
          <div *ngIf="isEdit">
            <div class="" *ngFor="let item of eventSelected.detail.listePersonnelParPoste" style="margin: 1px;">
              <div class="row" *ngIf="!item.chauffeur ||  (item.chauffeur && !item.chauffeur.posteSupprime)">
                <div class="col-sm-1" style="padding:0px">
                  <img src="assets/images/icons/avatar-default.svg" alt="avatar" />
                </div>
                <div class="col-sm-11" style="padding: 5px 0px;">
                  <span *ngIf="!item.chauffeur || (item.chauffeur && !item.chauffeur.id)"> A
                    définir</span>
                  <span *ngIf="item.chauffeur && item.chauffeur.id">{{ (item.chauffeur.nom || '')
                    + '
                    '+ (item.chauffeur.prenom || '') }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-sm-12" [ngClass]="{'div':(isEdit && !eventSelected.detail.histo), 'divRecreate': is_recreate    }"
        *ngIf="param.gestionCQC && (isEdit || (planning.partenaire || planning.partenaireAffiche))"
        style="padding-bottom: 8px;" (click)="planning.isPartenaire = true; editEvent(eventSelected, 7)">
        <label> Partenaire </label>
        <div class="col-sm-12" *ngIf="planning.partenaire && planning.partenaire.id">
          <div class="">
            <div class="row">
              <div class="col-sm-1" style="padding:0px">
                <img src="assets/images/icons/avatar-default.svg" alt="avatar" />
              </div>
              <div class="col-sm-11" style="padding: 5px 0px;">
                {{ (planning.partenaire ? (planning.partenaire.nom ||
                planning.partenaire.libelleObjetEntite) : '') }}
              </div>
            </div>
          </div>

        </div>
      </div>
      <div class="col-sm-12 p-0">
        <div class="col-sm-6"
          [ngClass]="{'div':(isEdit && !eventSelected.detail.histo), 'divRecreate': is_recreate    }"
          *ngIf="(isEdit)  || (planning.facturation)" (click)="editEvent(eventSelected, 7.1, '#acompte')">
          <label> Acompte </label>
          <div style="margin-bottom: 5px;">{{ planning.isAcompte ? planning.acompte: '' }}</div>
        </div>
        <div class="col-sm-6"
          [ngClass]="{'div':(isEdit && !eventSelected.detail.histo), 'divRecreate': is_recreate    }"
          *ngIf="(isEdit) || (planning.facturation)" (click)="editEvent(eventSelected, 7.1, '#contrat')">
          <label> Contrat </label>
          <div style="margin-bottom: 5px;"> {{ planning.isContrat ? planning.numContrat : '' }}
          </div>
        </div>
      </div>

      <div class="col-sm-12" style="padding: 0px">
        <div id="btn-nBSDMan" class="col-sm-12"
          [ngClass]="{'div':(isEdit && !eventSelected.detail.histo), 'divRecreate': is_recreate    }"
          *ngIf="isEdit || (planning.numBSDD && !planning.numBSDDfocus)"
          (click)="editEvent(eventSelected, 9, '#numbsdd')" style="    white-space: nowrap;">
          <label> N° BSD manuel </label>
          <span style="margin-bottom: 5px;"> {{ planning.numBSDD }} </span>
        </div>
      </div>

      <div class="col-sm-6" [ngClass]="{'div':(isEdit && !eventSelected.detail.histo), 'divRecreate': is_recreate    }"
        *ngIf="(isEdit)  || (planning.infofact || planning.prereseigner)"
        (click)="editEvent(eventSelected, 9, '#infofact')">
        <label> Infos Fact </label>
        <div style="margin-bottom: 5px;">{{ isEdit ? eventSelected.detail.infosFact : planning.infofact }}</div>
      </div>
      <div class="col-sm-6" [ngClass]="{'div':(isEdit && !eventSelected.detail.histo), 'divRecreate': is_recreate    }"
        *ngIf="(isEdit) || (planning.infosupp || planning.prereseigner)"
        (click)="editEvent(eventSelected, 9, '#infosup')">
        <label> Infos Supp </label>
        <div style="margin-bottom: 5px;"> {{ isEdit ? eventSelected.detail.infosSup : planning.infosupp }}
        </div>
      </div>
    </div>
    <div class="col-sm-12 btn-foot">
      <button class="pull-left btn-close" id="log" *ngIf="isEdit"
        (click)="common.getLogs(eventSelected.detail.id, '49', modalService);">
        Logs
      </button>
      <button class="btn-close" id="supprimer" *ngIf="!isHistoLoc && isEdit && !eventSelected.detail.histo"
        (click)="openSupprModal()">
        Supprimer
      </button>
    </div>
  </div>
  <div class="fiche" #fiche id="fiche"
    [ngStyle]="{'width': (showFichechantier || showFicheclt || isProgrammation || isModeEquipe || showHistorique) ? '552px' : '0'}">
    <div class="ficheclt" *ngIf="showFichechantier" [ngStyle]="{'right': (isEdit && modifier) ? '550px' : '550px'}">
      <app-fiche-chantier [chantier]="showFichechantier"
        [client]="isEdit ? eventSelected.detail.client : planning.client" [edit]="isEditChantier"
        (hidefunction)="hideChantier()" (validefunction)="updateChantier($event)" (addfunction)="createChantier($event)"
        [add]="addChantier"></app-fiche-chantier>
    </div>
    <div class="fichechantier" *ngIf="showFicheclt" [ngStyle]="{'right': (isEdit && modifier) ? '550px' : '550px'}">
      <app-fiche-client [position]="true" [client]="addClient ? '' : eventSelected.detail.client.id"
        (hidefunction)="addClient ? showFicheCltadd() : showFiche()"
        (addfunction)="addClient ? afterAddClt($event) : false" [add]="addClient"></app-fiche-client>
    </div>

    <div class="ficheclt" *ngIf="isProgrammation" [ngStyle]="{'right': (modifier) ? '550px' : '550px'}">
      <app-programmations [programme]="mouvBenneProgramme" [module] = "'ecoloc'" (hidefunction)="showProgrammation()"
        (saveFerier)="saveJourFerier($event)" [isHistoLoc]="isHistoLoc" [depuisDT]="true"
        (saveSusp)="saveSuspension($event)" (savePeriode)="savePeriode($event)"></app-programmations>
    </div>

    <div class="ficheclt" *ngIf="isModeEquipe" style="width: calc(100% - 550px);max-width: 960px;"
      [ngStyle]="{'right': (modifier) ? '550px' : '550px'}">
      <app-equipe-ecoloc [mouvement]="objEquipe" [sitePrestEdit]="idSitePrestEdit" [dateDebut]="planning.dateStart"
        [dateFin]="planning.dateEnd" [isHistoLoc]="isHistoLoc" (save)="saveEquipe($event)"
        (hidefunction)="showEquipeFct()"></app-equipe-ecoloc>
    </div>

    <div class="ficheclt" *ngIf="showHistorique" style="width: calc(100% - 550px);max-width: 960px;"
      [ngStyle]="{'right': (modifier) ? '550px' : '550px'}">
      <app-histo-prest [prestation]="eventSelected.detail ? eventSelected.detail : planning"
        (hidefunction)="showHistoPrest()" (recreate)="recreatePrest($event)"></app-histo-prest>
    </div>

    <div class="ficheclt" *ngIf="isPlusPrest" [ngStyle]="{'right': (modifier) ? '550px' : '550px'}">
      <app-plus-prest [equipes]="objEquipe" [dataMotifSuppression]="dataMotifSuppression" [locationMateriel]="eventSelected.detail ? eventSelected.detail : planning"
        (hidefunction)="showPlusPrest()" [param]="param" [listeLocationsSupplementaires]="listeLocationsSupplementaires"
        (annuleUneLocation)="savePlusPrestAnnule($event)" (validefunction)="savePlusPrest($event)"></app-plus-prest>
    </div>
  </div>
  <div class="fiche" #fiche id="fiche" [ngStyle]="{'width': (showMsg || showDoc) ? '552px' : '0'}">
    <div class="ficheclt" *ngIf="showMsg" [ngStyle]="{'right': (isEdit && modifier) ? '550px' : '550px'}"
      style="padding-top: 5px;">
      <app-messages-bon [row]="eventSelected.detail" style="width: 100%; height: 100%;" [depuisPlanning]="true"
        (hidefunction)="showMessage()"></app-messages-bon>
    </div>
    <div class="ficheclt" *ngIf="showDoc" [ngStyle]="{'right': (isEdit && modifier) ? '550px' : '550px'}"
      style="padding: 10px 5px;">
      <app-document-bon-ecoloc [row]="eventSelected.detail" style="width: 100%; height: 100%;" [depuisPlanning]="true"
        (validefunction)="showDocument()"></app-document-bon-ecoloc>
    </div>
  </div>
</div>

<ng-template #template>
  <div class="modal-header">
    <h4 class="modal-title pull-left">Motif de suppression</h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="common.closeModal()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body" style="height: auto">
    <div class="col-sm-12 p-0" *ngIf="dataMotifSuppression && dataMotifSuppression.length">
      <div class="form-group items col-sm-12 p-0">
        <label class="col-sm-3 champ" style="padding:0px">
          Motif suppression :
        </label>
        <div class="col-sm-9 champ" style="padding-right: 0px">
          <app-autocomplete [placeholder]="'Motif de suppression'"
            (selectfunction)="planning.motifSuppression = $event;" [results]="dataMotifSuppression" [label]="''"
            id="modedepaie autoMotif" [disablefocus]="true" [isCombo]="true"
            [defaultsearch]="planning.motifSuppression && planning.motifSuppression.id ? planning.motifSuppression.libelle || planning.motifSuppression.libelleObjetEntite : ''"
            [dropdownclass]="'dropDownPrixNego'"></app-autocomplete>
        </div>
      </div>
    </div>
    <div class="col-sm-12 p-0" *ngIf="dataMotifSuppression && dataMotifSuppression.length">
      <div class="form-group items col-sm-12 p-0">
        <label class="col-sm-3 champ" style="padding:0px">
          Libelle :
        </label>
        <div class="col-sm-9 champ" style="padding-right: 0px">
          <input type="text" class="col-sm-12 form-control" [(ngModel)]="planning.motifannulation"
            (keyup.enter)="confirmDeleteBon()" autofocus autocomplete="off" style="margin-bottom: 15px;">
        </div>
      </div>
    </div>
    <div class="col-sm-12 p-0" *ngIf="!dataMotifSuppression || (dataMotifSuppression && !dataMotifSuppression.length)">
      <input type="text" class="col-sm-12 form-control" [(ngModel)]="planning.motifannulation"
        (keyup.enter)="confirmDeleteBon()" autofocus autocomplete="off" style="margin-bottom: 15px;">
    </div>
    <div class="text-right col-sm-12 p-0">
      <button type="button" class=" btn-close btn-valider" (click)="confirmDeleteBon()"> Valider</button>
      <button type="button" class=" btn-close" (click)="common.closeModal()"> Annuler</button>
    </div>
  </div>
</ng-template>

<ng-template #templateSupressionFille>
  <div class="modal-header">
    <h4 class="modal-title pull-left">Motif de suppression</h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="common.closeModal()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body" style="height: auto">
    <div class="col-sm-12 p-0" *ngIf="dataMotifSuppression && dataMotifSuppression.length">
      <div class="form-group items col-sm-12 p-0">
        <label class="col-sm-3 champ" style="padding:0px">
          Motif suppression :
        </label>
        <div class="col-sm-9 champ" style="padding-right: 0px">
          <app-autocomplete [placeholder]="'Motif de suppression'" (selectfunction)="motifSuppression = $event;"
            [results]="dataMotifSuppression" [label]="''" id="modedepaie autoMotif" [disablefocus]="true"
            [isCombo]="true"
            [defaultsearch]="motifSuppression && motifSuppression.id ? motifSuppression.libelle || motifSuppression.libelleObjetEntite : ''"
            [dropdownclass]="'dropDownPrixNego'"></app-autocomplete>
        </div>
      </div>
    </div>
    <div class="col-sm-12 p-0" *ngIf="dataMotifSuppression && dataMotifSuppression.length">
      <div class="form-group items col-sm-12 p-0">
        <label class="col-sm-3 champ" style="padding:0px">
          Libelle :
        </label>
        <div class="col-sm-9 champ" style="padding-right: 0px">
          <input type="text" class="col-sm-12 form-control" [(ngModel)]="motifAnnulationFille"
            (keyup.enter)="confirmDeleteBonFille()" autofocus autocomplete="off" style="margin-bottom: 15px;">
        </div>
      </div>
    </div>
    <div class="col-sm-12 p-0" *ngIf="!dataMotifSuppression || (dataMotifSuppression && !dataMotifSuppression.length)">
      <input type="text" class="col-sm-12 form-control" [(ngModel)]="motifAnnulationFille"
        (keyup.enter)="confirmDeleteBonFille()" autofocus autocomplete="off" style="margin-bottom: 15px;">
    </div>

    <div class="text-right col-sm-12 p-0">
      <button type="button" class=" btn-close btn-valider" (click)="confirmDeleteBonFille()"> Valider</button>
      <button type="button" class=" btn-close" (click)="common.closeModal()"> Annuler</button>
    </div>
  </div>
</ng-template>

<ng-template #format>
  <div class="modal-header">
    <h4 class="modal-title pull-left">Choix du format </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="common.closeModal()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body" style="height: auto">
    <div>
      <ul class="list-group listeformat" *ngIf="formatPerso.length">
        <li class="list-group-item" *ngFor="let item of formatPerso" (click)="formatprs = item"
          [ngClass]="{'formatselected': formatprs.id === item.id}">
          {{ item.libelleObjetEntite }}
        </li>
      </ul>

      <span *ngIf="!formatPerso.length"> Aucun format disponible. Veuillez en définir au moins un </span>

    </div>
    <div class="text-right" style="margin-top: 15px;">
      <button type="button" class=" btn-close btn-valider" *ngIf="!formatPerso.length" (click)="common.closeModal()">
        Fermer
      </button>
      <button type="button" class=" btn-close btn-valider" *ngIf="formatPerso.length" (click)="initImprimerBon()">
        Valider
      </button>
      <button type="button" class=" btn-close" (click)="common.closeModal()"> Annuler</button>
    </div>
  </div>
</ng-template>

<ng-template #msg>
  <div class="modal-body" style="height: auto">
    <div>
      <div class="col-sm-12">
        <label class="cofirmemsg"> {{ error }} </label>
      </div>
    </div>
    <div class="text-right" style="margin-top: 15px;">
      <button type="button" class=" btn-close btn-valider" (click)="common.closeModal()"> Fermer</button>
    </div>
  </div>
</ng-template>

<ng-template #champInvalid>
  <div class="modal-body" style="height: auto">
    <div>
      <div class="col-sm-12">
        <label class="cofirmemsg"> {{ error }} </label>
      </div>
    </div>
    <div class="text-right" style="margin-top: 15px;">
      <button type="button" class=" btn-close btn-valider" (click)="common.closeModal();showChampIvalid()">
        Fermer</button>
    </div>
  </div>
</ng-template>

<ng-template #programConfirme>
  <div class="modal-header">
    <h4 class="modal-title pull-left"> Confirmation </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="common.closeModal()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body" style="height: auto">
    <div>
      <div class="col-sm-12">
        <label class="cofirmemsg"> Vous êtes en train de modifier une prestation programmée. </label>
        <label class="cofirmemsg"> Voulez-vous appliquer les modifications sur toutes les prestations du
          programme? </label>
        <label class="cofirmemsg"> Attention. Cette opération peut prendre plusieurs dizaines de secondes
        </label>
      </div>
    </div>
    <div class="text-right" style="margin-top: 15px;">
      <button type="button" class=" btn-close btn-valider"
        (click)="updateAll = true;common.closeModal(); validerUpdate();"> OUI
      </button>
      <button type="button" class=" btn-close" (click)="updateAll = false; common.closeModal(); validerUpdate();">
        NON
      </button>
    </div>
  </div>
</ng-template>

<ng-template #confirmeImpBonSansLeader>
  <div class="modal-header">
    <h4 class="modal-title pull-left"> Confirmation </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="common.closeModal()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body" style="height: auto">
    <div>
      <div class="col-sm-12">
        <label class="cofirmemsg"> Il n'y a pas de leader positionné sur la prestation
          {{ eventSelected && eventSelected['detail'] && eventSelected['detail'].bon ?
          eventSelected['detail'].bon.numBon : '' }}<br />
          Souhaitez-vous tout de même lancer l'impression ? </label>
      </div>
    </div>
    <div class="text-right" style="margin-top: 15px;">
      <button type="button" class=" btn-close btn-valider" (click)="common.closeModal(); imprimerBon()"> OUI
      </button>
      <button type="button" class=" btn-close" (click)="common.closeModal();"> NON</button>
    </div>
  </div>
</ng-template>


<ng-template #confirmePrestPostprogramme>
  <div class="modal-header">
    <h4 class="modal-title pull-left"> Suppression des prestations post programmée </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="common.closeModal();refuseSupPrestPostprogramme()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body" style="height: auto">
    <div>
      <div class="col-sm-12">
        <label class="cofirmemsg"> Voulez-vous supprimer les prestations dont la date est postérieure à la date de fin de la programmation? </label>
      </div>
    </div>
    <div class="text-right" style="margin-top: 15px;">
      <button type="button" class=" btn-close btn-valider" (click)="common.closeModal(); acceptSupPrestPostprogramme()"> OUI
      </button>
      <button type="button" class=" btn-close" (click)="common.closeModal();refuseSupPrestPostprogramme()"> NON</button>
    </div>
  </div>
</ng-template>

<ng-template #changedate>
  <div class="modal-header">
    <h4 class="modal-title pull-left"> Raison report </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="common.closeModal();">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body" style="height: auto">
    <div class="col-sm-12">
      <div class="col-sm-12" style="padding: 0">
        <label for="from"> Raison report : </label>
        <textarea class="form-control" rows="3" [(ngModel)]="raisonReport"></textarea>
      </div>
    </div>
    <div class="text-right col-sm-12" style="margin-top: 15px;">
      <button type="button" class=" btn-close btn-valider" (click)="update();"> Valider
      </button>
      <button type="button" class=" btn-close" (click)="common.closeModal();"> Fermer</button>
    </div>
  </div>
</ng-template>

<ng-template #loadingSygetrack>
  <div class="modal-header">
    <h4 class="modal-title pull-left">{{ nomInformatiqueImbrique }} </h4>
  </div>
  <div class="modal-body" style="height: auto">
    <div>
      <div class="col-sm-12" id="container-msg-sygetrack">
        <label class="cofirmemsg" style="font-family: Roboto-Black; font-size: 15px; text-align: justify"
          [innerHTML]="msgSygetrack ? msgSygetrack : 'Attente du retour de ' + nomInformatiqueImbrique"></label>
      </div>
    </div>

    <div class="text-right" style="margin-top: 15px;" *ngIf="msgSygetrack">
      <button type="button" class=" btn-close btn-valider" (click)="closeSygetrack()"> Fermer </button>
    </div>
  </div>
</ng-template>

<div class="spinner" *ngIf="showSpinner===true">
  <div class="sk-fading-circle">
    <div class="sk-circle1 sk-circle"></div>
    <div class="sk-circle2 sk-circle"></div>
    <div class="sk-circle3 sk-circle"></div>
    <div class="sk-circle4 sk-circle"></div>
    <div class="sk-circle5 sk-circle"></div>
    <div class="sk-circle6 sk-circle"></div>
    <div class="sk-circle7 sk-circle"></div>
    <div class="sk-circle8 sk-circle"></div>
    <div class="sk-circle9 sk-circle"></div>
    <div class="sk-circle10 sk-circle"></div>
    <div class="sk-circle11 sk-circle"></div>
    <div class="sk-circle12 sk-circle"></div>
  </div>
</div>